import { Tooltip } from "antd";
import React, { useCallback, useMemo } from "react";
import styles from "./index.module.scss";
import iContact from "@/modules/tm/assets/detail/negotiate-price.png";
import iBuy from "@/modules/tm/assets/detail/price-white.png";
import { TMDetailCtx } from "@/pages/tm-detail/[code]";
import { TMSubClassifyModel } from "@/modules/tm/api/tm/tm-model";
import TMDefines from "@/modules/tm/defines/tm-defines";
import KST from "@/common/tools/kst";
import AppRouter from "@/common/app/router";

export interface ITMDetailInfoAreaProps {
  code: string;
  category: number;
  subCategory: TMSubClassifyModel[];
}

const TMDetailInfoArea: React.FC<ITMDetailInfoAreaProps> = (props) => {
  const { code, category, subCategory } = props;

  // ---------------- Data ----------------

  // 分类
  const categoryValue = useMemo(() => {
    let cValue = category >= 10 ? `${category}类` : `0${category}类`;
    return cValue + "-" + TMDefines.Categories[category - 1];
  }, [category]);

  // 用途参考
  const subCategoryUse = useMemo(() => {
    return subCategory.reduce<string>((previous, current) => {
      return previous + " " + current.name;
    }, "");
  }, [subCategory]);

  // 类似群组
  const subCategoryCode = useMemo(() => {
    // 过滤相同的值
    let set = new Set();
    for (const obj of subCategory) {
      set.add(obj.code);
    }

    var value = "";
    set.forEach((v) => {
      value += v;
      value += " ";
    });
    return value;
  }, [subCategory]);

  // ---------------- Events ----------------

  // 点击了立即咨询
  const onTapContact = useCallback(() => {
    KST.call();
  }, []);

  // ---------------- UI ----------------

  const uiCategory = (
    <div className={`${styles.info} flex-row`}>
      <div className={styles.title}>商标分类：</div>
      <div className={styles.value}>{categoryValue}</div>
    </div>
  );

  const uiSubCategoryUse = (
    <div className={`${styles.info} flex-row`}>
      <div className={styles.title}>用途参考：</div>
      <div style={{flex: 1}} className="flex-col">
        <Tooltip title={subCategoryUse}>
          <div className={styles.value}>{subCategoryUse}</div>
        </Tooltip>
        <div className={styles.notice}>温馨提示：以上适用项目仅供参考，详情请咨询顾问</div>
      </div>
    </div>
  );

  const uiSubCategoryCode = (
    <div className={`${styles.info} flex-row`}>
      <div className={styles.title}>类似群组：</div>
      <Tooltip title={subCategoryCode}>
        <div className={styles.value}>{subCategoryCode}</div>
      </Tooltip>
    </div>
  );

  const createButton = useCallback(
    ({
      icon,
      title,
      btnClass,
      onTap,
    }: {
      icon: string;
      title: string;
      btnClass?: string;
      onTap?: () => void;
    }) => {
      return (
        <div className={`${styles.button} ${btnClass} flex-row-center`} onClick={onTap}>
          <img src={icon} alt="" />
          <span>{title}</span>
        </div>
      );
    },
    []
  );

  const buttonArray = (
    <TMDetailCtx.Consumer>
      {(value) => {
        const { state, onTapBuy } = value;
        var noLogin = true;
        if (state && state.token && state.token.length > 0) {
          noLogin = false;
        }

        return (
          <div className={`${styles.buttonContainer} flex-row`}>
            {createButton({
              icon: iContact,
              title: "立即咨询",
              btnClass: styles.buttonContact,
              onTap: onTapContact,
            })}
            {createButton({
              icon: iBuy,
              title: "立即购买",
              btnClass: styles.buttonBuy,
              onTap: () => {
                // 未登录，先跳转你登录
                if (noLogin) {
                  const redirect = window.location.href;
                  window.location.href =
                    window.location.origin + AppRouter.User.login({ redirect });
                }
                // 已登录，发起购买
                else {
                  onTapBuy?.(code);
                }
              },
            })}
          </div>
        );
      }}
    </TMDetailCtx.Consumer>
  );

  return (
    <div className={styles.container}>
      {uiCategory}
      {uiSubCategoryUse}
      {uiSubCategoryCode}
      {buttonArray}
    </div>
  );
};

export default TMDetailInfoArea;
